import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import mdToHtml from '../utils/mdToHtml';

const FAQs = ({ title, faqsData, className, locale }) => {
  const [open, toggleFaq] = useState(null);
  const handleToggle = (openId) => toggleFaq(open === openId ? null : openId);

  return (
    <div className={className}>
      <h3 className='section-title mb-50'>{title}</h3>

      <div className='section-faq'>
        {faqsData.map( ({ question, answerUk, answerEn, answerSe }, idx) => {
          return(
            <div key={idx} className={cx('faq-wrapper', { 'active': open === idx })}>
              <button
              className='button-faq'
              aria-controls={`faq${idx}`}
              aria-expanded={open === idx ? 'true' : 'false'}
              onClick={() => handleToggle(idx)}
              >
                {question}
              </button>
              <div id={`faq${idx}`} role='region' className='text-faq' tabIndex='-1'>
                {answerUk && locale === 'uk' ? <div dangerouslySetInnerHTML={{ __html: mdToHtml(answerUk) }} /> : '' }
                {answerEn && locale === 'en' ? <div dangerouslySetInnerHTML={{ __html: mdToHtml(answerEn) }} /> : '' }
                {answerSe && locale === 'se' ? <div dangerouslySetInnerHTML={{ __html: mdToHtml(answerSe) }} /> : '' }
                {!answerEn && !answerSe && locale !== 'uk' ? <div dangerouslySetInnerHTML={{ __html: mdToHtml(answerUk) }} /> : '' }
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};

FAQs.propTypes = {
  title: PropTypes.string.isRequired,
  faqsData: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.node.isRequired,
    answerUk: PropTypes.node.isRequired,
  })).isRequired,
  className: PropTypes.string.isRequired,
};

FAQs.defaultProps = {
  title: 'General FAQs',
  className: '',
};

export default FAQs;
